"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IChargeMethod = exports.CalculatedBy = exports.CountingUnit = exports.ChargeType = void 0;
const openapi_1 = require("../../../openapi");
var ChargeType;
(function (ChargeType) {
    ChargeType["Flat"] = "flat";
    // Percentage = 'percentage';
})(ChargeType = exports.ChargeType || (exports.ChargeType = {}));
var CountingUnit;
(function (CountingUnit) {
    CountingUnit["ActualTotal"] = "actualtotal";
    CountingUnit["BaseQty"] = "baseqty";
    // Carriers = "carriers",
    CountingUnit["ControlTotal"] = "controltotal";
    // FulfillmentInvoicing = "fulfillmentinvoicing",
    CountingUnit["HundredWeight"] = "hundredweight";
    CountingUnit["ItemClass"] = "itemclass";
    CountingUnit["LineItems"] = "lineitems";
    CountingUnit["Location"] = "location";
    CountingUnit["Lot"] = "lot";
    CountingUnit["MU"] = "mu";
    CountingUnit["MoveableUnits"] = "moveableunits";
    CountingUnit["Number"] = "number";
    CountingUnit["NumberOfPackagedUnits"] = "numberofpackagedunits";
    CountingUnit["NumberOfPalletized"] = "numberofpalletized";
    CountingUnit["NumUnits1"] = "numunits1";
    CountingUnit["NumUnits2"] = "numunits2";
    CountingUnit["PackagingUnits"] = "packagingunits";
    CountingUnit["PrimaryUnits"] = "primaryunits";
    CountingUnit["Qty"] = "qty";
    CountingUnit["SecondaryUnits"] = "secondaryunits";
    // Shipping = "shipping",
    CountingUnit["ShortTon"] = "shortton";
    CountingUnit["SKU"] = "sku";
    CountingUnit["TotalMUs"] = "totalmus";
    CountingUnit["TotalPackages"] = "totalpackages";
    CountingUnit["TotalQty"] = "totalqty";
    CountingUnit["TotalVolume"] = "totalvolume";
    CountingUnit["TotalWeight"] = "totalweight";
    CountingUnit["Transaction"] = "transaction";
    CountingUnit["Unique"] = "unique";
    CountingUnit["UniqueMULabels"] = "uniquemulabels";
    CountingUnit["Volume"] = "volume";
    CountingUnit["TotalKits"] = "totalkits";
})(CountingUnit = exports.CountingUnit || (exports.CountingUnit = {}));
var CalculatedBy;
(function (CalculatedBy) {
    // Area = "area",
    // ChargeTotal = "chargetotal",
    CalculatedBy["Count"] = "count";
    CalculatedBy["CountLessOtherUoms"] = "countlessotheruoms";
    CalculatedBy["HundredWeight"] = "hundredweight";
    CalculatedBy["ShortTon"] = "shortton";
    CalculatedBy["Volume"] = "volume";
    CalculatedBy["Weight"] = "weight";
    CalculatedBy["AreaSqFt"] = "areasqft";
    CalculatedBy["AreaSqM"] = "areasqm";
})(CalculatedBy = exports.CalculatedBy || (exports.CalculatedBy = {}));
class IChargeMethod {
    chargeType;
    countingUnit;
    calculatedBy;
    roundUp;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(ChargeType) })
], IChargeMethod.prototype, "chargeType", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(CountingUnit) })
], IChargeMethod.prototype, "countingUnit", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(CalculatedBy) })
], IChargeMethod.prototype, "calculatedBy", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'boolean' })
], IChargeMethod.prototype, "roundUp", void 0);
exports.IChargeMethod = IChargeMethod;
